import React from 'react';
import { useForm } from 'react-hook-form';
import moment from 'moment';
import searchBarApis from '../../utils/searchBarApis';
import ClearIcon from '@material-ui/icons/Clear';
import {
  Button,
  FieldDatePicker,
  FieldSelect,
  ValidationError,
  CircularProgressLoader,
  AccessControl,
  PERMISSION_KEYS,
  PERMISSION_TYPES,
  FieldSearchBar,
} from '../../components';
import { FormattedMessage, injectIntl } from '../../utils/reactIntl';
import Usertype from './RolesTypes.json';
import carretDown from '../../assets/svg/caretdown.svg';
import exp from '../../assets/svg/export.svg';
import '../../components/LayoutWrapperMain/LayoutWrapperMain.global.scss';

interface Props {
  handleFormSubmit: any,
  handleExport: any,
  handleResetSorts: any,
  loaderExport: any,
  intl: any,
  error: any,
}

enum ButtonTypes {
  'button',
  'submit',
  'reset',
  undefined
}

const RoleManagementFilterForm: React.FC<Props> = (props: Props) => {
  const {
    handleFormSubmit,
    handleResetSorts,
    intl,
    error,
    handleExport,
    loaderExport,
  } = props;
  const formProps = useForm();
  const [showFilter, setShowFilter] = React.useState(true);
  const [toggle, setToggle] = React.useState(false);
  const handleReset = () => {
    formProps.reset({
      search: '',
      startDate: null,
      endDate: null,
      userType: '',
    });
    handleResetSorts();
  };
  return (
    <form
      className="filterForm"
      onSubmit={formProps.handleSubmit(handleFormSubmit)}
    >
      <div className="filter_container">
        <div className="filterSearch">
          <div>
            <div className="filter">
              Filter
              <span
                className="closeBtn"
                role="presentation"
                onClick={() => setTimeout(() => {
                  setShowFilter((prevState) => !prevState);
                }, 200)}
              >
                {showFilter
                  ? <ClearIcon />
                  : <img src={carretDown} alt="down" />}
              </span>
            </div>
            <div className="fieldSet">
              <FieldSearchBar
                searchURL={searchBarApis.rolesManagement}
                formProps={formProps}
                name="search"
                label={intl.formatMessage({ id: 'RoleManagement.search.label' })}
                id="search"
              />
            </div>
          </div>
          <AccessControl
            permissionKey={PERMISSION_KEYS.ROLE_MANAGEMENT}
            accessType={PERMISSION_TYPES.EDIT}
          >
            <div className="userRightExport">
              {!loaderExport
                ? (
                  <>
                    <span>
                      <img
                        src={exp}
                        alt="export"
                        role="presentation"
                        onClick={() => setToggle((prevState: boolean) => !prevState)}
                      />
                    </span>
                    {toggle && (
                      <ul className="userrigthToggle">
                        <li
                          role="presentation"
                          onClick={() => handleExport('XLSX')}
                        >
                          {intl.formatMessage({ id: 'RoleManagement.label.expot.xlsx' })}
                        </li>
                        <li
                          role="presentation"
                          onClick={() => handleExport('CSV')}
                        >
                          {intl.formatMessage({ id: 'RoleManagement.label.export.csv' })}
                        </li>
                      </ul>
                    )}
                  </>
                ) : <div className="exportProgressBar"><CircularProgressLoader /></div>}
            </div>
          </AccessControl>
        </div>
        {showFilter && (
          <div>
            <p>
              Added on
            </p>
            <div className="filterOptions">
              <div className="datepickerField">
                <FieldDatePicker
                  id="startDate"
                  name="startDate"
                  label={intl.formatMessage({ id: 'RoleManagement.startDate.label' })}
                  formProps={formProps}
                  maxDate={formProps.watch('endDate') !== null
                    ? formProps.watch('endDate')
                    : moment().subtract(0, 'years').format('YYYY-MM-DD')}
                />
              </div>
              <div className="datepickerField">
                <FieldDatePicker
                  id="endDate"
                  name="endDate"
                  label={intl.formatMessage({ id: 'RoleManagement.endDate.label' })}
                  formProps={formProps}
                  minDate={formProps.watch('startDate') !== null
                    ? formProps.watch('startDate')
                    : moment().subtract(118, 'years').format('YYYY-MM-DD')}
                />
              </div>
              <div className="userType">
                <FieldSelect
                  id="userType"
                  name="userType"
                  variant={false}
                  label={intl.formatMessage({ id: 'RoleManagement.status.label' })}
                  formProps={formProps}
                  options={Usertype}
                />
              </div>
              <div className="buttonWrapper">
                <Button buttonType={ButtonTypes.submit} className="button">
                  <FormattedMessage id="RoleManagement.apply.label" />
                </Button>
                <Button onClick={handleReset} className="button">
                  <FormattedMessage id="RoleManagement.reset.label" />
                </Button>
              </div>
            </div>
            <ValidationError error={error} />
          </div>
        )}
      </div>
    </form>
  );
};

export default injectIntl(RoleManagementFilterForm);
